module.exports = __webpack_public_path__ + "img/ECNP2PGNJ.b644671a.svg";